
<template>

	<b-overlay class="h-100" :show="wait">
	<elements v-if="group_id" ref="table"
		style="min-height: 100%;"
		:service="service"
		:attrs="attrs"
		:additional_query="{ 'group' : group_id }"
		essence_name_genetive_case="правила"
		essence_name_for_plural_1="правило"
		essence_name_for_plural_234="правила"
		essence_name_for_plural_others="правил"
		not_able_for_delete
		without_export
		without_details
		without_back_button
		:without_add="!(check_roles([ 'group_tree' ]) && !not_editable && ids_for_edit.length == 0)"
		:with_filters="ids_for_edit.length == 0"
		:with_show_attrs="false"
		:many_edit="check_roles([ 'group_tree' ])"
		:draggable="false"
		:resizable="false"
		@change_ids_for_edit="change_ids_for_edit"
	>

		<template v-slot:title><h4>Правила кодирования</h4></template>

		<template v-slot:modal_dialogs>

			<addOne ref="add_element" :group_id="group_id" :not_editable="not_editable" v-on:need_refresh="refresh"/>

		</template>

		<template v-slot:first_nav_items>

			<b-button v-if="$refs.table && $refs.table.ids_for_edit.length && check_roles([ 'group_tree' ])" variant="outline-primary-secondary" v-on:click="calc">

				<span>Применить кодирование</span><base-icon name="calc" size="md" />

            </b-button>

			<b-button v-if="$refs.table && $refs.table.ids_for_edit.length && !not_editable && check_roles([ 'group_tree' ])" v-b-tooltip:fullscreen.hover.bottomright variant="outline-danger" title="Удалить настройку кодирования" v-on:click="delete_many">

                <base-icon name="delete" />

			</b-button>

		</template>

		<template v-slot:table_cell_params="cell_data">

			<b-button v-if="cell_data.data.field.key == 'settings'" size="sm" @click="() => edit_one(cell_data.data.item)" variant="outline-primary-dark">

				<base-icon name="tune" />

            </b-button>

		</template>

	</elements>
	</b-overlay>

</template>

<script>

import api from "../../../api"
import attrs from "../../../api/attrs"
import elements from "../../elements/"
import addOne from './set_rules'

export default
{
    components :
    {
		elements,
		addOne,
    },

    data()
    {
		return {

			group_id : null,
			service : "coding_factors",
			wait : false,
			ids_for_edit: [],

			//TODO
			not_editable : this.$root.not_editable,

			attrs :
			[
				{
					key : "settings",
					label : "",
					visible : true,
					visible_if_no_visible : true,
					params : true,
					thClass: "cell_settings_head",
					tdClass: "cell_settings",
					thStyle: "width: 64px;"
				},
				{
					key : "attr_name",
					label : "Наименование ЦОФ",
					type : "str",
					sortable : true,
					visible : true,
					visible_if_no_visible : true,
					in_query : true,
				},
				{
					key : "attr_type_2",
					label : "Тип ЦОФ",
					type : "str",
					sortable : true,
					visible : true,
					visible_if_no_visible : true,
					in_query : true,
					reference :
					{
						simple_values : [ { label : "Качественный", value : "Качественный" }, { label : "Количественный", value : "Количественный" } ],
					},
				},
				{
					key : "attr_type_3",
					label : "Вид ЦОФ",
					type : "str",
					sortable : true,
					visible : true,
					visible_if_no_visible : true,
					in_query : true,
					reference :
					{
						simple_values : [ { label : "Справочник", value : "Справочник" }, { label : "Показатель", value : "Показатель" }, { label : "Пространственный", value : "Пространственный" } ],
					},
				},
				{
					key : "attr_type",
					label : "Тип данных",
					type : "str",
					sortable : true,
					visible : true,
					visible_if_no_visible : true,
					in_query : true,
					reference :
					{
						simple_values :
						[
							{ label : "Строка", value : "str" },
							{ label : "Число", value : "number" },
							{ label : "Булево", value : "bool" },
							{ label : "Дата", value : "date" },
							{ label : "Время", value : "time" },
							{ label : "Дата и время", value : "datetime" },
						]
					},
				},
				// {
				// 	key : "unit",
				// 	label : "Единица измерения",
				// 	type : "str",
				// 	sortable : true,
				// 	visible : true,
				// 	visible_if_no_visible : true,
				// 	in_query : true,
				// },
				{
					key : "has_rules",
					label : "Заданы правила кодирования",
					type : "bool",
					sortable : true,
					visible : true,
					visible_if_no_visible : true,
					in_query : true,
				},
				{
					key : "apply",
					label : "Применены",
					type : "bool",
					sortable : true,
					visible : true,
					visible_if_no_visible : true,
					in_query : true,
				},
            ],
            selected : new Set(),
        }
    },

	created() 
	{
		this.group_id = this.$route.params.id
	},

    methods :
    {
		refresh()
		{
			this.$refs.table.refresh(1, false, null, true)
		},

		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

		change_ids_for_edit(ids)
		{
			this.ids_for_edit = ids
		},

        select(id, value)
        {
            var selected = new Set(this.selected)
            
            value
            ? selected.add(id)
            : selected.delete(id)

            this.selected = selected
        },

		calc()
		{
			var bad_factors = []

			this.$refs.table.ids_for_edit.forEach(
				id =>
				{
					const factor = this.$refs.table.elements.find(factor => factor.id == id)

					if(! factor.has_rules)
						bad_factors.push(factor.attr_name)
				})

			if(bad_factors.length > 0)
			{
				const h = this.$createElement
				var content = [ h("p", { class: [ "text-left" ] }, [ "Не заданы правила кодирования для факторов: " ]) ]

				bad_factors.forEach(name => content.push(h("p", { class: [ "text-left" ] }, [ name ])))

				api.show_notification(this, content)
			}
			else
				api.call_long_operation(this, "Кодирование", "coding_factors", "calc_many", { group : this.group_id, factors : this.$refs.table.ids_for_edit },
					response =>
					{
						api.open_response_url(response)

						this.$refs.table.ids_for_edit = []
						this.$refs.table.all_edit_checked = false

						attrs.load(this).then(() => this.refresh())
					},
					{ success_msg : "Кодирование завершено" }
				)
		},

		delete_many()
		{
			var promises = []

			this.wait = true

			this.$refs.table.ids_for_edit.forEach(id => promises.push(api.call(this, this.service, "delete", { id : id }, () => {
				api.show_notification(this, "Настройка кодирования удалена")
			})))

			Promise.all(promises).then(
				() =>
					attrs.load(this).then(
						() =>
						{
							this.refresh()

							this.wait = false
							this.$refs.table.ids_for_edit = []
							this.$refs.table.all_edit_checked = false
						})
				)
		},

		edit_one(factor)
		{
			this.$refs.add_element.execute(factor)
		},
    }
}

</script>

<style scoped>
* >>> .cell_settings_head
{
	text-align: center;
}
</style>
